import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 17.01H22V19H2V17.01ZM2 13H22V11.01H2V13ZM2 5V6.99H22V5H2Z" fill={ fill || 'currentColor' } />
    </svg>
);
